// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__3incE","rotation":"SmallLoader_rotation__gRB0c"};